/*
 * @Author: tao_yang
 * @Date: 2022-06-07 16:25:54
 * @LastEditors: tao_yang
 * @LastEditTime: 2022-12-23 11:24:28
 * @Description: 滚到到顶部
 */
import { useLocation } from 'react-router-dom';

const useReStoreScrollTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        try {
            let scrollY = sessionStorage.getItem(pathname);
            if (scrollY || scrollY === 0) {
                scrollY && document.body.scrollTo(0, scrollY);
            } else {
                document.body.scrollTo(0, 0);
            }
        } catch (error) {
            throw error;
        }
        return () => {
            try {
                sessionStorage.setItem(pathname, window.scrollY); //这里使用scrollY是获取文档window在垂直页面
            } catch (error) {
                //的滚动值，如果是特定DOM元素用srcollTop
                throw error;
            }
        };
    }, [pathname]);
};
export default useReStoreScrollTop;
